import { handleFlyoutOpen, handleFlyoutClose } from './handleFlyout';
import handleNavItemHide from './handleNavItemHide';

const filterFlyoutButtons = document.querySelectorAll('[data-hasFilter="true"]');
const filterFlyoutClose = document.getElementsByClassName('flyout__close');

Array.from(filterFlyoutButtons).forEach(item => {
    item.addEventListener('click', (e) => {
        handleFlyoutOpen(e);
        handleNavItemHide(true);
    });
});

Array.from(filterFlyoutClose).forEach(section => {
    section.addEventListener('click', () => {
        handleFlyoutClose();
        handleNavItemHide(false);
    });
});




// WEBPACK FOOTER //
// ./src/scripts/components/filter-flyout/index.js